import React, { useState } from "react";

export const PasswordStrengthMeter = ({ name, handleChange, passwordStrength }) => {
  const [showPassword, setShowPassword] = useState(false);
  //Shows password
  const handleShowPassword = (event) => {
    event.preventDefault();
    setShowPassword(!showPassword);
  };
  const passwordStrengthMeterStyle = {
    marginBottom: passwordStrength?.obj?.text ? '0px' : '1.5rem'
  }
  const passwordStrengthMeterMessageStyle = {
    color: passwordStrength?.obj?.color,
    fontSize: '16px'
  }
  return (
    <div className="password-strength-meter" style={passwordStrengthMeterStyle}>
      <div className="input-group">
        <input
          type={showPassword ? "text" : "password"}
          className="form-control"
          name={name}
          onChange={handleChange}
        />
        <span className="input-group-text" onClick={handleShowPassword}>
          {showPassword ? (
            <i className="bi bi-eye-slash-fill"></i>
          ) : (
            <i className="bi bi-eye-fill"></i>
          )}
        </span>
      </div>
      <div className="text-end" style={passwordStrengthMeterMessageStyle}>{passwordStrength?.obj?.text}</div>
    </div>
  );
};
